export const indicatorsExecutedvsNoProjected = (chartData) => {
  const cats =
    Array.isArray(chartData?.cats) && chartData.cats.length
      ? chartData.cats
      : ["A", "B", "C", "D"];

  const LEN = cats.length;

  const safeArr = (arr) => {
    if (!Array.isArray(arr)) return Array(LEN).fill(0);
    const out = Array(LEN).fill(0);
    for (let i = 0; i < LEN; i++) {
      const n = Number(arr[i]);
      out[i] = Number.isFinite(n) ? n : 0;
    }
    return out;
  };

  const noProy_asignadas = safeArr(chartData?.projected?.proy_asignadas);
  const noProy_delegadas = safeArr(chartData?.projected?.proy_delegadas);
  const noProy_continuas = safeArr(chartData?.projected?.proy_continuas);

  const eje_asignadas = safeArr(chartData?.executed?.eje_asignadas);
  const eje_delegadas = safeArr(chartData?.executed?.eje_delegadas);
  const eje_continuas = safeArr(chartData?.executed?.eje_continuas);

  const totalNoProy = cats.map(
    (_, i) => noProy_asignadas[i] + noProy_delegadas[i] + noProy_continuas[i]
  );

  const totalEje = cats.map(
    (_, i) => eje_asignadas[i] + eje_delegadas[i] + eje_continuas[i]
  );

  const totalCat = cats.map((_, i) => totalNoProy[i] + totalEje[i]);

  const pctEjeCat = cats.map((_, i) =>
    totalCat[i] ? (100 * totalEje[i]) / totalCat[i] : 0
  );

  const COLOR_ASIG = "#3A7BD5";
  const COLOR_DEL = "#8E44AD";
  const COLOR_CONT = "#16A085";

  return {
    chart: {
      type: "column",
      spacingTop: 40,
      events: {
        render: function () {
          const chart = this;
          if (chart.customLabel) chart.customLabel.destroy();

          chart.customLabel = chart.renderer
            .text(
              "⬅️ <b>Columna izquierda:</b> No Planificadas &nbsp;&nbsp; | &nbsp;&nbsp; <b>Columna derecha:</b> Ejecutadas ➡️",
              chart.plotLeft + chart.plotWidth / 2,
              chart.plotTop - 10
            )
            .attr({ align: "center" })
            .css({
              color: "#444",
              fontSize: "13px",
              fontFamily: "Arial, sans-serif"
            })
            .add();
               chart.renderer
              .label('', 0, 0, "", 0, 0, true)
              .css({
                color: "#000",
                textAnchor: "middle",
                fontWeight: "700"
              })
              .attr({ align: "center" })
              .add();
        }
      }
    },

    title: { text: "" },
    subtitle: {
      text: " "
    },
    xAxis: {
      categories: cats,
      title: { text: "Clasificación" },
      lineWidth: 0
    },

    yAxis: {
      min: 0,
      title: { text: "Cantidad de Actividades" },
      gridLineDashStyle: "ShortDash",
      stackLabels: {
        enabled: true,
        style: { fontWeight: "bold", fontSize: "11px" },
        formatter: function () {
          return this.total;
        }
      }
    },

    legend: {
      align: "center",
      verticalAlign: "bottom",
      itemStyle: { fontSize: "12px" }
    },

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const i = this.points[0].point.index;

        const noProy = {
          asignadas: noProy_asignadas[i],
          delegadas: noProy_delegadas[i],
          continuas: noProy_continuas[i],
          total: totalNoProy[i]
        };

        const eje = {
          asignadas: eje_asignadas[i],
          delegadas: eje_delegadas[i],
          continuas: eje_continuas[i],
          total: totalEje[i]
        };

        return `
          <div style="min-width:240px; padding:5px 0;">
            <div style="font-size:15px; font-weight:700; margin-bottom:8px; color:#444;">
              Clasificación ${cats[i]}
            </div>

            <div style="font-weight:700; margin-bottom:4px;">
              TOTAL No proyectadas <span style="float:right;">${noProy.total}</span>
            </div>

            <div style="color:${COLOR_ASIG}">Actividades Asignadas <span style="float:right; color:black;">${noProy.asignadas}</span></div>
            <div style="color:${COLOR_DEL}">Actividades Delegadas <span style="float:right; color:black;">${noProy.delegadas}</span></div>
            <div style="color:${COLOR_CONT}">Actividades Continuas <span style="float:right; color:black;">${noProy.continuas}</span></div>
            <br>
            <div style="font-weight:700; margin-bottom:4px;">
              TOTAL Ejecutadas <span style="float:right;">${eje.total}</span>
            </div>
            <div style="color:${COLOR_ASIG}">Actividades Asignadas <span style="float:right; color:black;">${eje.asignadas}</span></div>
            <div style="color:${COLOR_DEL}">Actividades Delegadas <span style="float:right; color:black;">${eje.delegadas}</span></div>
            <div style="color:${COLOR_CONT}">Actividades Continuas <span style="float:right; color:black;">${eje.continuas}</span></div>
          </div>
        `;
      }
    },

    plotOptions: {
      column: {
        stacking: "normal",
        borderWidth: 0,
        groupPadding: 0.1,
        pointPadding: 0.02,
        dataLabels: {
          enabled: true,
          style: { textOutline: "none", fontSize: "10px" },
          formatter: function () {
            const total = this.total || 0;
            return total > 0 && this.y / total >= 0.15 ? this.y : null;
          }
        }
      }
    },

    series: [
      {
        name: "Asignadas",
        data: noProy_asignadas,
        color: COLOR_ASIG,
        stack: "No Planificadas",
        showInLegend: true
      },
      {
        name: "Delegadas",
        data: noProy_delegadas,
        color: COLOR_DEL,
        stack: "No Planificadas",
        showInLegend: true
      },
      {
        name: "Continuas",
        data: noProy_continuas,
        color: COLOR_CONT,
        stack: "No Planificadas",
        showInLegend: true
      },

      {
        name: "Asignadas",
        data: eje_asignadas,
        color: COLOR_ASIG,
        stack: "Ejecutadas",
        showInLegend: false
      },
      {
        name: "Delegadas",
        data: eje_delegadas,
        color: COLOR_DEL,
        stack: "Ejecutadas",
        showInLegend: false
      },
      {
        name: "Continuas",
        data: eje_continuas,
        color: COLOR_CONT,
        stack: "Ejecutadas",
        showInLegend: false
      }
    ],

    annotations: [
      {
        labels: cats.map((cat, i) => ({
          point: {
            xAxis: 0,
            yAxis: 0,
            x: i,
            y: Math.max(totalNoProy[i], totalEje[i])
          },
          text: `${pctEjeCat[i].toFixed(0)}%`,
          backgroundColor: "rgba(0,0,0,0.06)",
          borderColor: "rgba(0,0,0,0.15)",
          style: { fontSize: "10px", fontWeight: "600" },
          y: -20
        }))
      }
    ],

    credits: { enabled: false }
  };
};
